import React from 'react';
import GatsbyImage from 'gatsby-image';

import RichText from '../RichText/RichText';
import SocialSharingButtons from '../SocialSharingButtons/SocialSharingButtons';
import { getFluidProps } from '../../utils/sanity';

import styles from './eventHero.module.less';
import DateIcon from '../icons/DateIcon';

export const EventDate = ({ startDate, endDate }) => {
  if (!startDate) {
    return null;
  }
  let formatted = new Date(startDate).toLocaleDateString('en', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'utc',
  });
  if (endDate) {
    const firstHalf = new Date(startDate).toLocaleDateString('en', {
      month: 'long',
      day: '2-digit',
      timeZone: 'utc',
    });
    const secondHalf = new Date(endDate).toLocaleDateString('en', {
      day: '2-digit',
      timeZone: 'utc',
    });
    const thirdHalf = new Date(endDate).getFullYear();
    formatted = `${firstHalf} - ${secondHalf}, ${thirdHalf}`;
  }
  return (
    <div className={`${styles.date} event-card__date`}>
      <DateIcon />
      {/* Visually hidden text for screen readers */}
      <span className="visually-hidden">Event happening on </span>
      {formatted}
    </div>
  );
};

const EventHero = (props) => {
  const imageFluidProps =
    props.image &&
    getFluidProps(
      { assetId: props.image.asset._ref, ...props.image },
      { maxWidth: 1250 },
    );
  return (
    <>
      {imageFluidProps && (
        <GatsbyImage className={styles.image} fluid={imageFluidProps} />
      )}
      <section className={styles.wrapper}>
        <h1 className={styles.title}>{props.title}</h1>
        <h2>
          <EventDate startDate={props.startDate} endDate={props.endDate} />
        </h2>
        {props.excerpt && (
          <RichText
            blocks={props.excerpt}
            renderContainerOnSingleChild={true}
            className={styles.excerpt}
          />
        )}
        <SocialSharingButtons className={styles.social} />
      </section>
    </>
  );
};

export default EventHero;
